import './HeaderControls.scss';

import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';

interface SelectOption {
  value: string;
  label: string;
}

interface SelectConfig {
  label: string;
  value: string;
  options: SelectOption[];
  disabled?: boolean;
  readOnly?: boolean;
  onChange: (value: string) => void;
}

interface HeaderControlsProps {
  selects: SelectConfig[];
}

const HeaderControls = ({ selects }: HeaderControlsProps) => {
  return (
    <Box className='header-controls'>
      {selects.map((select, index) => (
        <FormControl key={index} className='select-control'>
          <InputLabel>{select.label}</InputLabel>
          <Select
            value={select.value}
            onChange={(event: SelectChangeEvent) => select.onChange(event.target.value)}
            className='select-field'
            inputProps={{ 'aria-label': select.label }}
            label={select.label}
            disabled={select.disabled}
            readOnly={select.readOnly}
          >
            {select.options.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ))}
    </Box>
  );
};

export default HeaderControls;
